<template>
    <div class="space-forms check-selector">
       <div class="group" v-for="(group, name) in groups">
           <h4 v-text="name"></h4>
           <form-checkbox v-for="form in group"
                            :key="form.id"
                            v-model="selected"
                            :form="form"
                            @input="updateItems">
           </form-checkbox>
       </div>
        <div class="show-hiden-forms text-danger">
            <a href="#" @click="showHidenForms()">(Show Hidden Forms)</a>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                type: Array,
                required: true,
            },
            forms: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                selected: this.value
            }
        },

        created() {
            App.bus.$on('hide-form', form => {
                var hiddenForms = Storage.get(`user-${App.config.userId}-hiden-forms`);
                if (!hiddenForms) hiddenForms = [];
                hiddenForms.push(form.id);
                Storage.set(`user-${App.config.userId}-hiden-forms`, hiddenForms);
            })
        },

        methods: {
            updateItems() {
                this.$emit('input', this.selected)
            },

            showHidenForms() {
                Storage.set(`user-${App.config.userId}-hiden-forms`, []);
                App.bus.$emit('show-hiden-forms');
            },
        },

        watch: {
            value(newValue) {
                if (!newValue.length) {
                    this.selected = [];
                }
            },
        },

        computed: {

            groups() {
                return _.groupBy(this.forms, form => {
                    return form.group.code;
                });
            }
        }
    }
</script>
